import { NgClass } from '@angular/common';
import { Component, computed, inject, input, output, signal } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import InputStarsUiComponent from '@iupics-components/standard/fields/input-stars-ui/input-stars-ui.component';
import AvatarUiComponent from '@iupics-components/standard/user/avatar-ui/avatar-ui.component';
import { UICreatorService } from '@iupics-manager/managers/ui-creator/ui-creator.service';
import { TranslateModule } from '@ngx-translate/core';
import { defer, from, iif, map, of, startWith, switchMap } from 'rxjs';
import { DocServerUrlPipe } from '../../../../../../iupics-util/pipes/doc-server-url/doc-server-url.pipe';
import { LoadingDirective } from '../../../../../directives/loading.directive';
import { VendorProfileData } from './vendor-profile-data';

@Component({
  selector: 'iu-vendor-profile',
  standalone: true,
  imports: [NgClass, LoadingDirective, InputStarsUiComponent, TranslateModule, AvatarUiComponent],
  templateUrl: './vendor-profile.component.html',
  styleUrl: './vendor-profile.component.scss',
})
export default class VendorProfileComponent {
  protected uiCreator = inject(UICreatorService);
  private docServerUrlPipe = new DocServerUrlPipe();

  data = input.required<VendorProfileData>();

  readonly editButtonEmitter = output<MouseEvent>();

  isLoading = signal(true);
  imgError = signal(false);

  hasImg = computed(() => (this.data()?.profilePicture?.trim()?.length ?? 0) > 0);

  private infos = toObservable(this.data).pipe(
    startWith({
      id: -1,
      fullName: '',
      profilePicture: undefined,
      loaded: false,
    }),
    switchMap((data) =>
      iif(
        () => !!data.profilePicture,
        defer(() =>
          from(this.docServerUrlPipe.transform(this.data()?.profilePicture)).pipe(
            map((res) => ({ ...data, profilePicture: res }))
          )
        ),
        defer(() => of(data))
      )
    ),
    map((data) => ({
      id: data.id,
      fullname: data.fullName,
      pictureURL: data.profilePicture,
    }))
  );

  avatarInfos = toSignal(this.infos);

  editBtnClick(event: MouseEvent): void {
    this.editButtonEmitter.emit(event);
  }

  changeLoadingState(state: boolean): void {
    this.isLoading.set(state);
  }
}
